import { Component, HostListener } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {
  // Component State Properties
  isSticky: boolean = false;
  isMenuCollapsed: boolean = true;
  isDropdownOpen: boolean = false;

  // Window Scroll Event Listener for Sticky Header
  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    // Page 45px scroll hone ke baad header sticky mode mein switch hoga
    this.isSticky = scrollPosition > 45;
  }

  // Toggle mobile navbar menu
  toggleMenu(): void {
    this.isMenuCollapsed = !this.isMenuCollapsed;
  }

  // Toggle dropdown menu
  toggleDropdown(event: Event): void {
    event.preventDefault();
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  // Close menus when navigating
  closeMenu(): void {
    this.isMenuCollapsed = true;
    this.isDropdownOpen = false;
  }
}
